// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/_layout.tsx"); } },
  "./draft.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/draft.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/index.tsx"); } },
  "./privacy.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/privacy.tsx"); } },
  "./result.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/result.tsx"); } },
  "./support.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/support.tsx"); } },
  "./terms.tsx": { enumerable: true, get() { return require("/Users/ronkantor/Projects/1-t/src/app/terms.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;